(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aara-category-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aara-category-nav')) {
    customElements.define('aara-category-nav', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => {
          const row = this.querySelector('nav');
          const active = row.querySelector('[aria-current="page"]');
          if (active && row.scrollWidth > row.clientWidth) {
            row.scrollLeft = active.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft - (row.clientWidth - active.offsetWidth) / 2;
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aara-editable-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aara-banner-slideshow')) {
    customElements.define('aara-banner-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.aara-editable-hero__slide')];
        this.controls = this.querySelector('.aara-editable-hero__controls');
        if (this.slides.length < 2 || !this.controls) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dots = [...this.querySelectorAll('[data-slide]')];
        this.toggle = this.querySelector('[data-action="toggle"]');
        this.status = this.querySelector('[data-status]');
        this.current = this.querySelector('[data-current]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.interval = Math.max(3000, Number(this.dataset.interval) || 5000);
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.hovered = false;
        this.focused = false;
        this.visible = true;
        this.controls.hidden = false;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || !this.controls.contains(button)) return;
          if (button.dataset.slide !== undefined) this.show(Number(button.dataset.slide));
          if (button.dataset.action === 'previous') this.show(this.index - 1);
          if (button.dataset.action === 'next') this.show(this.index + 1);
          if (button.dataset.action === 'toggle') {
            this.paused = !this.paused;
            if (!this.paused) { this.hovered = false; this.focused = false; }
            this.updatePlayback();
          }
        }, options);
        this.addEventListener('pointerenter', (event) => { if (event.pointerType !== 'touch') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) { this.paused = true; this.updatePlayback(); } }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (index !== -1) { this.paused = true; this.updatePlayback(); this.show(index); }
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => { this.visible = entries[0].isIntersecting; this.schedule(); });
          this.observer.observe(this);
        }
        this.show(0);
        this.updatePlayback();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === this.index);
          slide.setAttribute('aria-hidden', String(i !== this.index));
          slide.inert = i !== this.index;
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
        this.current.textContent = String(this.index + 1);
        this.dataset.currentSlide = String(this.index + 1);
        this.schedule();
      }
      updatePlayback() {
        this.dataset.paused = String(this.paused);
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.status.setAttribute('aria-live', this.paused ? 'polite' : 'off');
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden) {
          this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
